import { FunctionComponent } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { NavigationListItemButton, NavigationItemVerticalPadding } from '@cbridge-tools/navigation-item';
import { LinkWithSearchParams } from '../LinkWithSearchParams/LinkWithSearchParams';
import { INavigationBlockItemProps } from './NavigationBlockItem.interface';

export const NavigationBlockItem: FunctionComponent<INavigationBlockItemProps> = (props) => {
  const { label, href, isSelected, hoverAction, secondaryAction } = props;

  return (
    <ListItem
      sx={{
        p: 0,
        overflowX: 'hidden',
      }}
      secondaryAction={secondaryAction}
    >
      <NavigationListItemButton
        py={NavigationItemVerticalPadding.sm}
        selected={isSelected}
        component={LinkWithSearchParams}
        to={href}
      >
        <ListItemText
          primary={label}
          slotProps={{
            primary: {
              noWrap: true,
            },
          }}
        />
        {hoverAction}
      </NavigationListItemButton>
    </ListItem>
  );
};
